import * as t from 'io-ts';

export const UserProfileContactsType = t.interface({
    contactEmail: t.union([t.string, t.null, t.undefined]),
    contactPhone: t.union([t.string, t.null, t.undefined]),
    confirmedEmail: t.union([t.string, t.null, t.undefined]),
    confirmedPhone: t.union([t.string, t.null, t.undefined]),
});

export interface UserProfileContactsDto extends t.TypeOf<typeof UserProfileContactsType> {
}

class UserProfileContacts {
    contactEmail: string | null;
    contactPhone: string | null;
    confirmedEmail: string | null;
    confirmedPhone: string | null;

    constructor(params: UserProfileContactsDto) {
        this.contactEmail = params.contactEmail ?? null;
        this.contactPhone = params.contactPhone ?? null;
        this.confirmedEmail = params.confirmedEmail ?? null;
        this.confirmedPhone = params.confirmedPhone ?? null;
    }
}

export default UserProfileContacts;
